import { ISingleIdParams } from '../types/actionParams';
import { IProjectActions } from '../types/IProjectActions';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class GetProjectActionsRequest extends Request<ISingleIdParams, IProjectActions> {
  constructor(id: string) {
    super('getProjectActions', { id: id });
  }
}
